import React from 'react';
import Contact from './Contact/Contact';
const Help = () => {
  return (
    <div>
      <Contact/>
    </div>
  );
}

export default Help;
